import http from "../http-common"

class SocialMediaContentService {
    getocialMediaContent() {
        return http.get("/master-page/social-media")
    }
}


export default new SocialMediaContentService();